import request from '@/utils/request'
import qs from 'qs'

export function upload(data) {
    return request({
        url: '/api-admin/file/upload',
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data',
        },
        data: data
    })
}

export function deleteFile(filePath) {
    return request({
        url: '/api-admin/file/delete',
        method: 'post',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        params: { filePath },
    })
}